import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';
import reloadFormById from 'ia-react-core/~/actions/form-fn/reloadFormById';
import { ActionMap } from 'ia-react-core/~/interfaces/ReducerActions';
import submitFormById from '../../../actions/form-fn/submitFormById';
import resetFormById from '../../../actions/form-fn/resetFormById';
import clearFormById from '../../../actions/form-fn/clearFormById';
import cancelSubmitFormById from '../../../actions/form-fn/cancelSubmitFormById';
import completeSubmitFormById from '../../../actions/form-fn/completeSubmitFormById';

const formActions = ({ formId }: { formId: number }) => ({
  submit: (...args: ParametersExceptFirst<typeof submitFormById>) => submitFormById(formId, ...args),
  cancelSubmit: (...args: ParametersExceptFirst<typeof cancelSubmitFormById>) => cancelSubmitFormById(formId, ...args),
  completeSubmit: (...args: ParametersExceptFirst<typeof completeSubmitFormById>) => completeSubmitFormById(formId, ...args),
  clear: (...args: ParametersExceptFirst<typeof clearFormById>) => clearFormById(formId, ...args),
  reset: (...args: ParametersExceptFirst<typeof resetFormById>) => resetFormById(formId, ...args),
  reload: (...args: ParametersExceptFirst<typeof reloadFormById>) => reloadFormById(formId, ...args),
} as ActionMap);

export default formActions;
